<template>
    <div>
        <div class="flex"
             :class="{ 'items-center': ! description, 'items-start': description }"
        >
            <input :id="id"
                   :name="name"
                   type="radio"
                   class="form-radio h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                   :checked="isChecked"
                   @input="$emit('input', value)"
            >

            <div class="ml-3"
                 :class="{ '-mt-px': description }"
            >
                <label :for="id"
                       @click.prevent="$emit('input', value)"
                >
                    <span class="block text-sm leading-5 font-medium text-gray-700">
                        <slot></slot>
                    </span>
                </label>
                <p class="text-gray-500 text-sm"
                   @click="$emit('input', value)"
                   v-if="description"
                >
                    {{ description }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
	    model: {
	        prop: 'selectedValue',
        },

		props: {
		    selectedValue: {
		        required: true,
            },

            value: {
		        required: true,
            },

            id: {
                type: String,
            },

            name: {
                type: String,
            },

            description: {
		        type: String,
            }
        },

        computed: {
	        isChecked() {
	            return this.selectedValue === this.value;
            }
        }
	}
</script>
